import { useEffect, useRef, useState } from 'react';

/// Acompanha a largura do elemento e diz se ficou abaixo de `width`.
export function useNarrowerThan<T extends HTMLElement>(width: number) {
    const ref = useRef<T>(null);
    const [narrow, setNarrow] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return undefined;

        const observer = new ResizeObserver(([entry]) => setNarrow(entry.contentRect.width < width));

        observer.observe(element);
        return () => observer.disconnect();
    }, [width]);

    return { ref, narrow };
}
